import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, BookOpenIcon } from 'lucide-react';
const deliverables = ['La Guía Digital Lonchera Realista 15-Min: El manual paso a paso para dominar el ensamblaje.', 'Auditoría de Despensa Colombiana: Qué comprar exactamente en D1, Ara y Carulla para ahorrar tiempo y dinero.', 'La Matriz 3-2-1: El sistema visual para equilibrar nutrientes sin contar calorías.', 'Menú de Lunes a Viernes: 5 ejemplos reales de ensamblajes que se hacen en menos de 12 minutos.', 'Guía de Snacks y Bebidas: Cómo eliminar el azúcar de los jugos de caja sin protestas.'];
export function WhatYouGet() {
  return <section className="bg-white py-20 px-6" data-id="element-190">
      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="lg:col-span-5" data-id="element-192">
          <div className="bg-[#FFF8F0] p-8 rounded-3xl relative" data-id="element-193">
            <div className="absolute -top-6 -left-6 bg-[#2D6A4F] text-white p-4 rounded-2xl shadow-lg" data-id="element-194">
              <BookOpenIcon size={32} data-id="element-195" />
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/tdZ1Cq2TzA62qu4Fp7smN1/portada_laptop.png" alt="Contenido de la guía" className="rounded-xl shadow-md mt-4" data-id="element-196" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="lg:col-span-7" data-id="element-197">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2D6A4F] mb-8" data-id="element-198">
            Lo que obtienes hoy:
          </h2>

          <ul className="space-y-6" data-id="element-199">
            {deliverables.map((item, index) => {
            const [title, description] = item.split(': ');
            return <motion.li key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start space-x-4" data-id="element-200">
                  <div className="flex-shrink-0 mt-1 bg-[#2D6A4F]/10 p-1 rounded-full" data-id="element-201">
                    <CheckIcon className="text-[#2D6A4F]" size={20} strokeWidth={3} data-id="element-202" />
                  </div>
                  <div data-id="element-203">
                    <strong className="text-[#5C4B3A] block text-lg" data-id="element-204">
                      {title}
                      {description ? ':' : ''}
                    </strong>
                    {description && <span className="text-[#5C4B3A]/80" data-id="element-205">{description}</span>}
                  </div>
                </motion.li>;
          })}
          </ul>
        </motion.div>
      </div>
    </section>;
}